import { ArrowDown } from "lucide-react";

const MammaHero = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(220 69% 2%), hsl(217 61% 10%))",
      }}
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(122,183,253,0.18) 0%, rgba(29,74,140,0.08) 35%, transparent 70%)",
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-24 text-center">
        <div className="inline-flex items-center px-4 py-2 mb-10 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm">
          <span className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-white/70 font-medium">
            Propuesta confidencial · Mamma Pasta
          </span>
        </div>

        <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-8">
          Un franquiciado
          <br />
          no compra un manual.
          <br />
          <span style={{ color: "#7ab7fd" }}>Compra una marca.</span>
        </h1>

        <p className="max-w-2xl mx-auto text-base md:text-lg text-white/70 leading-relaxed mb-10">
          El sistema para operar tu franquicia ya está listo.
          <br className="hidden md:block" />
          Falta construir lo que hace que alguien quiera comprarla.
        </p>

        <div className="inline-flex items-center px-4 py-2 mb-10 rounded-full border border-white/10 bg-white/5">
          <span className="text-xs md:text-sm text-white/70">
            Preparada para Ezequiel Gattino · Agosto 2026
          </span>
        </div>

        <div>
          <button
            onClick={() => scrollTo("inversion")}
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full text-base md:text-lg font-medium text-white transition-all duration-300 hover:scale-[1.02]"
            style={{
              background: "linear-gradient(135deg, #1d4a8c 0%, #7ab7fd 100%)",
              boxShadow: "0 10px 40px -10px rgba(122,183,253,0.5)",
            }}
          >
            Ver la inversión
            <ArrowDown className="w-5 h-5 transition-transform group-hover:translate-y-1" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default MammaHero;
